<app-header login='yes'></app-header>
<div class="container-fluid">
    <div class="responsive">
        <div class="row">
            <div class="col-md-2"></div>

            <div class="col-md-8">
                <app-sub-header [title]="title"></app-sub-header>
                <div class="row ">
                    <div class="col-md-12">
                        <app-alert-card size=2 [showtext]=false [others]="true" [data]="objArr" title="Details"
                            [route]="route">
                        </app-alert-card>
                    </div>

                </div>

                <div class="row margin-b">
                    <div class="col-md-12">
                        <div class="header" style="text-align: center;">
                            Request to manage profile
                        </div>
                        <small class="text-center d-block text-secondary">(All fields marked with asterisks(*) are
                            required)</small>
                    </div>

                </div>

                <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                    <div class="row margin-b">
                        <div class="col-md-12">

                            <div class="header main-backgroundcolor color margin-b">
                                Your Information
                            </div>


                            <div class="form-group">
                                <span class="requiredd">*</span><select class="form-control" formControlName="title"
                                    [ngClass]="{ 'is-invalid': submitted && f.title.errors }">
                                    <option value="">Select Prefix/Title</option>
                                    <option *ngFor="let props of prefixes" [value]="props.value">{{props.name}}</option>
                                </select>
                                <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                                    <div class="text-position" *ngIf="f.title.errors.required">{{errorMessage}}</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <span class="requiredd">*</span> <input type="text" formControlName="firstName"
                                    class="form-control" placeholder="First Name"
                                    [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }">
                                <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                    <div class="text-position" *ngIf="f.firstName.errors.required">{{errorMessage}}
                                    </div>
                                </div>

                            </div>

                            <div class="form-group">
                                <span class="requiredd">*</span> <input type="text" formControlName="lastName"
                                    class="form-control" placeholder="LastName"
                                    [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }">
                                <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                    <div class="text-position" *ngIf="f.lastName.errors.required">{{errorMessage}}</div>
                                </div>
                            </div>


                            <div formGroupName="connection">
                                <div class="form-group">
                                    <p *ngIf="showConnection" class="mb-1">A Staff Member's Contact Info Is Required To
                                        Verify Your
                                        Request</p>
                                    <span class="requiredd">*</span> <select class="form-control typeselect"
                                        formControlName="type" (change)="onChange($event.target.value)"
                                        [ngClass]="{ 'is-invalid': submitted && f.connection.get('type').errors }">
                                        <option value="" disabled>Select</option>
                                        <option *ngFor="let props of connections" [value]="props.value">{{props.name}}
                                        </option>

                                    </select>
                                    <div *ngIf="submitted && f.connection.get('type').errors" class="invalid-feedback">
                                        <div class="text-position" *ngIf="f.connection.get('type').errors.required">
                                            {{errorMessage}}</div>
                                    </div>
                                </div>


                                <div *ngIf="showConnection">
                                    <div class="form-group">
                                        <input type="text" formControlName="name" class="form-control"
                                            placeholder="Staff Name"
                                            [ngClass]="{ 'is-invalid': submitted && f.connection.get('name').errors }">
                                        <div *ngIf="submitted && f.connection.get('name').errors"
                                            class="invalid-feedback">
                                            <div class="text-position" *ngIf="f.connection.get('name').errors.required">
                                                {{errorMessage}}</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" formControlName="title" class="form-control"
                                            placeholder="Staff Title"
                                            [ngClass]="{ 'is-invalid': submitted && f.connection.get('title').errors }">
                                        <div *ngIf="submitted && f.connection.get('title').errors"
                                            class="invalid-feedback">
                                            <div class="text-position"
                                                *ngIf="f.connection.get('title').errors.required">
                                                {{errorMessage}}</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <input type="email" formControlName="email" class="form-control"
                                            placeholder="Staff Email"
                                            [ngClass]="{ 'is-invalid': submitted && f.connection.get('email').errors }">
                                        <div *ngIf="submitted && f.connection.get('email').errors"
                                            class="invalid-feedback">
                                            <div class="text-position"
                                                *ngIf="f.connection.get('email').errors.required">
                                                {{errorMessage}}</div>
                                            <div class="text-position" *ngIf="f.connection.get('email').errors.email">
                                                Email must be a
                                                valid email address</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" formControlName="phone" class="form-control"
                                            placeholder="Staff Contact Number"
                                            [ngClass]="{ 'is-invalid': submitted && f.connection.get('phone').errors }">
                                        <div *ngIf="submitted && f.connection.get('phone').errors"
                                            class="invalid-feedback">
                                            <div class="text-position"
                                                *ngIf="f.connection.get('phone').errors.required">
                                                {{errorMessage}}</div>
                                            <div style="text-align: right;" *ngIf="f.connection.get('phone').pattern">
                                                {{"Please enter valid url"}}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>



                            <div class="form-group">
                                <input type="text" formControlName="ravelUsername" class="form-control"
                                    placeholder="What is your personal Ravel profile username"
                                    [ngClass]="{ 'is-invalid': submitted && f.ravelUsername.errors }">
                                <div *ngIf="submitted && f.ravelUsername.errors" class="invalid-feedback">
                                    <div class="text-position" *ngIf="f.ravelUsername.errors.required">{{errorMessage}}
                                    </div>
                                </div>
                            </div>



                            <div class="form-group">
                                <span class="requiredd">*</span><textarea maxlength="200"
                                    formControlName="RoleDescription" class="form-control"
                                    placeholder="Briefly describe your role (Max 200)" rows="5"
                                    [ngClass]="{ 'is-invalid': submitted && f.RoleDescription.errors }"></textarea>

                                <div *ngIf="submitted && f.RoleDescription.errors" class="invalid-feedback">
                                    <div class="text-position" *ngIf="f.RoleDescription.errors.required">
                                        {{errorMessage}}</div>
                                </div>

                            </div>


                        </div>

                    </div>
                    <div class="row margin-b">
                        <div class="col-md-12">
                            <div class="header main-backgroundcolor color margin-b">
                                Contact Information </div>

                            <div class="form-group">
                                <p>In order to expedite the approval of this request, please use a contact email address
                                    that is associated with the organization whose profile you are requesting to manage.
                                    If
                                    you do not have an email address assocaited with the organization, please indicate
                                    that
                                    by checking the box below. </p>
                            </div>



                            <div class="form-group">
                                <span class="requiredd">*</span><input type="number" formControlName="contact"
                                    class="form-control" placeholder="Contact Number"
                                    [ngClass]="{ 'is-invalid': submitted && f.contact.errors }">
                                <div *ngIf="submitted && f.contact.errors" class="invalid-feedback">
                                    <div class="text-position" *ngIf="f.contact.errors.required">{{errorMessage}}</div>
                                    <div style="text-align: right;" *ngIf="f.contact.errors.pattern">
                                        {{"Please enter valid Contact Number"}}</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <span class="requiredd">*</span><input type="email" formControlName="email"
                                    class="form-control" placeholder="Email"
                                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <div class="text-position" *ngIf="f.email.errors.required">{{errorMessage}}</div>
                                    <div class="text-position" *ngIf="f.email.errors.email">
                                        Email must be a
                                        valid email address</div>
                                </div>

                            </div>


                            <div class="form-group">
                                <span class="requiredd">*</span><input type="text" formControlName="website"
                                    class="form-control" placeholder="organization website"
                                    [ngClass]="{ 'is-invalid': submitted && f.website.errors }">
                                <div *ngIf="submitted && f.website.errors" class="invalid-feedback">

                                    <div class="text-position" *ngIf="f.website.errors.required">{{errorMessage}}</div>
                                    <div style="text-align: right;" *ngIf="f.website.errors.pattern">
                                        {{"Please enter valid url"}}</div>
                                </div>
                            </div>
                            <hr>

                            <div class="form-group">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input type="checkbox" class="form-check-input" value="">We do not use an
                                        organizational
                                        domain
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">

                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input type="checkbox" (change)="onCheckbox($event)" class="form-check-input"
                                            value="false">
                                        We do not have a website
                                    </label>
                                </div>
                            </div>


                        </div>


                    </div>


                    <div class="row margin-b">
                        <div class="col-md-12">
                            <div class="header main-backgroundcolor color margin-b">
                                Organizational Structure </div>

                            <div class="form-group">
                                <p>Ravel Ministry profiles are required to maintain a non-profit status. Please
                                    provide as
                                    much information about your orgainzation's federal structure below.</p>
                            </div>

                            <div formGroupName="organization">
                                <div class="form-group">
                                    <span class="requiredd">*</span><input type="text" formControlName="ein"
                                        class="form-control"
                                        placeholder="Tax ID Number (US EIN or National Organization ID #)"
                                        [ngClass]="{ 'is-invalid': submitted && f.organization.get('ein').errors }">
                                    <div *ngIf="submitted && f.organization.get('ein').errors" class="invalid-feedback">
                                        <div class="text-position" *ngIf="f.organization.get('ein').errors.required">
                                            {{errorMessage}}</div>
                                    </div>
                                </div>

                                <div class="form-group" style="position: relative;">
                                    <input type="text" formControlName="guidedProfile" class="form-control"
                                        placeholder="GuideStar Profile Link (US non-profits)">
                                    <span (click)="onNavigate()" class="guide-link mx-3"
                                        [routerLink]="'https://www.guidestar.org'">
                                        <i class="link-icon fas fa-external-link-alt fa-spin fa-sm"
                                            style="color: #176663"></i>
                                    </span>
                                </div>

                                <div class="form-group">
                                    <input type="text" class="form-control" formControlName="bridgeNumber"
                                        placeholder="Other organizational, assocation or business registry link">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row margin-b">
                        <div class="col-md-12">

                            <div class="header main-backgroundcolor color margin-b">
                                Attachment (Upload any supporting documentation to help verify your request)</div>
                            <div class="form-group">
                                <label class="btn-bs-file btn btn-lg main-backgroundcolor color">
                                    Upload File
                                    <input type="file" accept=",image/*,.pdf" (change)="uploadBanner($event)" />
                                </label>
                                <input type="hidden" formControlName="documents"
                                    [ngClass]="{'is-invalid': submitted && f.documents.errors }">
                                <span class="ml-1" *ngIf="uploadedFile">{{uploadedFile.name}}</span>
                            </div>
                        </div>

                    </div>
                    <div class="row margin-b">
                        <div class="col-md-12">
                            <div class="header main-backgroundcolor color margin-b">
                                Authorized and Terms acceptance </div>
                            <div class="form-group">
                                <div class="form-check">
                                    <span class="requireddd">*</span>
                                    <input type="checkbox" formControlName="isAutherized" id="isAutherized"
                                        class="form-check-input"
                                        [ngClass]="{ 'is-invalid': submitted && f.isAutherized.errors }" />
                                    <label clas for="isAutherized" class="form-check-label " style="color: black !important;">I am authorized by this
                                        organization to update the information on Ravel</label>
                                    <div *ngIf="submitted && f.isAutherized.errors" class="invalid-feedback">
                                        Required</div>
                                </div>
                            </div>
                            <div class="form-group">

                                <div class="form-check">
                                    <span class="requireddd">*</span>
                                    <input type="checkbox" formControlName="isAgreed" id="isAgreed"
                                        class="form-check-input"
                                        [ngClass]="{ 'is-invalid': submitted && f.isAgreed.errors }" />
                                    <label for="isAgreed" class="form-check-label " style="color: black !important;">I agree to <a
                                        style="cursor: pointer; color: blue;" (click)="openAgree()">Terms
                                        of Services </a></label>
                                    <div *ngIf="submitted && f.isAgreed.errors" class="invalid-feedback">
                                        Required</div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="row margin-b">

                        <div class="col-md-12">
                            <div class="display">
                                <button type="submit" class="btn main-backgroundcolor color">Submit Request</button>
                                <button type="submit" class="btn main-backgroundcolor color margin-l">Cancel</button>

                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="col-md-2">

            </div>
        </div>



    </div>
</div>
